import { RestrictedDirective } from './restricted.directive';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [RestrictedDirective],
  exports: [RestrictedDirective]
})
export class RestrictedModule {}
